import request from '@/utils/request'

export function getAndroidLink() {
  return request({
    url: 'newApi/banner/androidListByH5',
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/home.js